"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignPurposes = void 0;
var CampaignPurposes;
exports.CampaignPurposes = CampaignPurposes;

(function (CampaignPurposes) {
  CampaignPurposes["EventInvitation"] = "event-invitation";
  CampaignPurposes["EventFollowUp"] = "event-follow-up";
  CampaignPurposes["DoorOpener"] = "lead-gen-door-opener";
  CampaignPurposes["DealAcceleration"] = "deal-acceleration";
  CampaignPurposes["LeadReEngagement"] = "lead-re-engagement";
  CampaignPurposes["NewCustomer"] = "new-customer-welcome";
  CampaignPurposes["Celebration"] = "celebration";
  CampaignPurposes["CustomerLoyalty"] = "customer-loyalty";
  CampaignPurposes["Renewal"] = "renewal-retention";
  CampaignPurposes["Partnership"] = "partnership";
  CampaignPurposes["Hr"] = "hr";
  CampaignPurposes["ThankYou"] = "thank-you";
  CampaignPurposes["Apology"] = "please-accept-our-apology";
  CampaignPurposes["Other"] = "other";
})(CampaignPurposes || (exports.CampaignPurposes = CampaignPurposes = {}));